import { render } from "./SearchBar.vue?vue&type=template&id=82ba54bc&scoped=true&ts=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=82ba54bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ba54bc"]])

export default __exports__